import React, { ReactNode } from 'react';
import { cn } from '../cn';
import { iconButtonVariants } from '../recipes/editor';

export function IconButton({
  variant = 'ghost',
  className,
  children,
  ...attrs
}: React.ButtonHTMLAttributes<HTMLButtonElement> & {
  variant?: 'ghost' | 'ghost-dark' | 'ghost-light';
  children: ReactNode;
}) {
  return (
    <button
      type="button"
      className={cn(iconButtonVariants({ variant }), className)}
      {...attrs}
    >
      {children}
    </button>
  );
}
